(function (runtime) {
    "use strict";

    /*
      売り切れた品の「入荷したら知らせて」（store #199・F51・テーマ側）
      ・会員は受け渡し口、メールの印つきで来た方は直接の口、それ以外はログインへ案内する
      ・受けてよい品かどうかの判定はサーバーが行う。ここは見た目と入力の世話だけ
      ・メールアドレスや顧客番号は画面から送らない
    */

    var CODE_PATTERN = /^\d{7}$/;
    var REQUEST_TIMEOUT_MS = 15000;
    var MEMBER_PATH = "restock-alerts/join";
    var returnedPages = new WeakMap();
    var DONE_CLASS = "nk-up__btn--done";
    var bound = typeof WeakSet === "function" ? new WeakSet() : null;

    function part(root, name) {
        return root.querySelector('[data-nk-restock="' + name + '"]');
    }

    function text(root, name) {
        var value = root.dataset[name];
        return value === undefined ? "" : value;
    }

    function setHidden(element, hidden) {
        if (element) {
            element.hidden = Boolean(hidden);
        }
    }

    function showStatus(state, message) {
        if (state.status) {
            state.status.textContent = message === undefined || message === null
                ? "" : String(message);
        }
    }

    function kxFromLocation(location) {
        var search = location && location.search ? String(location.search) : "";
        var match = /[?&]_kx=([^&#]+)/.exec(search);
        if (!match) {
            return "";
        }
        try {
            return decodeURIComponent(match[1]);
        } catch (error) {
            return "";
        }
    }

    /* 🛑 この端末に「登録済み」の印を残さない（#199 レビュー指摘）。
       予告品は coming→販売開始で二度と戻らないので永久の印でよかったが、
       再入荷は 売り切れ→戻る→また売り切れ を何度も往復する。印を残すと、
       サーバーは2度目の申し込みを受け付けられるのに、その端末だけ
       ボタンが押せないまま取り残される。
       いま登録済みかどうかはサーバーが知っている（`already` で返る）ので、
       押してもらってから正しい言葉を出す。 */
    function markDone(state) {
        state.done = true;
        if (state.notify) {
            state.notify.disabled = true;
            state.notify.classList.add(DONE_CLASS);
            state.notify.textContent = state.texts.doneButton;
        }
        setHidden(state.form, true);
    }

    function setBusy(state, busy) {
        state.busy = Boolean(busy);
        if (state.notify) {
            state.notify.disabled = state.busy || state.done;
        }
        if (state.send) {
            state.send.disabled = state.busy;
        }
        if (state.busy) {
            showStatus(state, state.texts.sending);
        }
    }

    // 戻り先は同じ店のパスとクエリだけ。新旧どちらのログイン方式でも品番を引き継ぐ。
    function rememberLogin(state, code) {
        try {
            var view = runtime;
            if (!view.crypto || typeof view.crypto.getRandomValues !== "function") { return ""; }
            var bytes = new Uint8Array(16);
            view.crypto.getRandomValues(bytes);
            var token = Array.prototype.map.call(bytes, function (byte) {
                return ("0" + byte.toString(16)).slice(-2);
            }).join("");
            view.sessionStorage.setItem("nk_restock_return:" + code, token);
            return token;
        } catch (error) {
            // 保存できない端末では、戻った後にもう一度押してもらう。
            return "";
        }
    }

    function consumeLogin(state, code, token) {
        try {
            if (!/^[0-9a-f]{32}$/.test(token || "")) { return false; }
            var storage = (runtime).sessionStorage;
            var key = "nk_restock_return:" + code;
            if (storage.getItem(key) !== token) { return false; }
            storage.removeItem(key);
            return true;
        } catch (error) {
            return false;
        }
    }

    function loginHref(base, location, code, token) {
        if (!base || typeof runtime.URL !== "function" || !location || !location.href
                || /[\\\u0000-\u001f\u007f]/.test(base)) {
            return "";
        }
        try {
            var current = new runtime.URL(location.href);
            var url = new runtime.URL(base, current.href);
            if (!/^https?:$/.test(url.protocol) || url.origin !== current.origin) { return ""; }
            current.searchParams.set("nk_restock", code);
            current.searchParams.delete("nk_restock_token");
            if (code && token) { current.searchParams.set("nk_restock_token", token); }
            var back = current.pathname + current.search;
            if (url.pathname.indexOf("/customer_authentication/") === 0) {
                url = new runtime.URL("/customer_authentication/login", current.href);
                url.searchParams.set("return_to", back);
            } else {
                url.searchParams.set("return_url", back);
            }
            return url.toString();
        } catch (error) {
            return "";
        }
    }

    function goLogin(state) {
        var token = rememberLogin(state, state.code);
        var href = loginHref(state.loginUrl, state.location, state.code, token);
        try {
            if (href && typeof state.location.assign === "function") {
                state.location.assign(href);
                return;
            }
        } catch (error) {
            // 移動できない場合もメール欄は開かず、既存の案内を出す。
        }
        showStatus(state, state.texts.unavailable);
    }

    function proxyOf() {
        var proxy = runtime.NKAppProxy;
        return proxy && typeof proxy.post === "function" ? proxy : null;
    }

    // 同じ品の部品が複数あっても、戻り後の自動申し込みはページ全体で一度だけ。
    function autoJoin(state) {
        if (!state.member) { return; }
        var url;
        try {
            url = new runtime.URL(state.location.href);
        } catch (error) {
            return;
        }
        var code = url.searchParams.get("nk_restock");
        if (!CODE_PATTERN.test(code || "") || code !== state.code) { return; }
        var claimed = returnedPages.get(state.documentRef);
        if (!claimed) {
            claimed = {};
            returnedPages.set(state.documentRef, claimed);
        }
        if (claimed[code]) { return; }
        if (!consumeLogin(state, code, url.searchParams.get("nk_restock_token"))) {
            // 外から来たリンクは対象を選ぶだけ。申し込みにはクリックが要る。
            if (state.notify && typeof state.notify.focus === "function") { state.notify.focus(); }
            clean();
            return;
        }
        claimed[code] = true;

        function clean() {
            try {
                // 待つ間に変わった他のクエリ・ハッシュと履歴の状態も残す。
                var current = new runtime.URL(state.location.href);
                current.searchParams.delete("nk_restock");
                current.searchParams.delete("nk_restock_token");
                if (state.history && typeof state.history.replaceState === "function") {
                    state.history.replaceState(state.history.state, "", current.pathname + current.search + current.hash);
                }
            } catch (error) {
                // 履歴を変えられなくても、ページの印で再送を防ぐ。
            }
        }

        var attempts = 0;
        function attempt() {
            if (state.done || state.busy) { clean(); return; }
            if (proxyOf()) {
                submit(state).then(clean, clean);
                return;
            }
            if (attempts >= 20) {
                showStatus(state, state.texts.unavailable);
                clean();
                return;
            }
            attempts += 1;
            runtime.setTimeout(attempt, 250);
        }
        attempt();
    }

    function readBody(response) {
        if (!response || typeof response.json !== "function") {
            return Promise.resolve(null);
        }
        return Promise.resolve(response.json()).catch(function () {
            return null;
        });
    }

    // サーバーの返事を、画面の言葉に写す。
    function interpret(state, response, body) {
        var texts = state.texts;
        var status = response ? response.status : 0;
        if (status === 200 && body && body.ok === true) {
            markDone(state);
            return {message: body.already ? texts.already : texts.done, done: true};
        }
        if (body && (body.code === "needs_account"
                || (status === 403 && body.code === "login_required"))) {
            return {login: true};
        }
        if (status === 400) {
            // 受付終了をメールアドレスの書式の誤りと混ぜない。
            if (body && body.error === "not accepting") {
                return {message: texts.unavailable};
            }
            return {message: state.member ? texts.error : texts.unavailable};
        }
        if (status === 404 && !state.member) {
            if (body && body.error === "profile not found") {
                return {login: true};
            }
            return {message: texts.unavailable};
        }
        if (state.member && body && (body.code === "rate_limited" || body.code === "busy")) {
            return {message: texts.rateLimited};
        }
        if (status === 429 || status === 503) {
            return {message: texts.rateLimited};
        }
        return {message: texts.error};
    }

    function submit(state) {
        if (state.busy || state.done || !state.code) {
            return Promise.resolve();
        }
        if (state.member ? !proxyOf() : (!state.kx || !state.endpoint || typeof state.fetchRef !== "function")) {
            showStatus(state, state.texts.unavailable);
            return Promise.resolve();
        }
        var payload = {code: state.code, locale: state.locale || "en"};
        if (!state.member) { payload.kx = state.kx; }
        setBusy(state, true);

        var aborter = !state.member && typeof runtime.AbortController === "function"
            ? new runtime.AbortController() : null;
        var timer = aborter ? runtime.setTimeout(function () {
            aborter.abort();
        }, REQUEST_TIMEOUT_MS) : null;
        var request = {
            method: "POST",
            mode: "cors",
            credentials: "omit",
            referrerPolicy: "origin",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(payload)
        };
        if (aborter) {
            request.signal = aborter.signal;
        }
        return Promise.resolve()
            .then(function () {
                if (state.member) {
                    return proxyOf().post(MEMBER_PATH, {body: payload, timeoutMs: REQUEST_TIMEOUT_MS})
                        .then(function (body) {
                            return interpret(state, {status: body && body.status || 200}, body);
                        });
                }
                return state.fetchRef(state.endpoint, request).then(function (response) {
                    return readBody(response).then(function (body) {
                        return interpret(state, response, body);
                    });
                });
            })
            .catch(function (error) {
                if (!state.member) {
                    // 口が閉じた場合も通信の失敗と区別できないため、既存の案内を出す。
                    return {message: state.texts.unavailable};
                }
                if (error && (error.kind === "rate_limited" || error.kind === "busy")) {
                    return {message: state.texts.rateLimited};
                }
                return interpret(state, {status: error && error.status}, error && error.payload);
            })
            .then(function (outcome) {
                if (timer !== null) {
                    runtime.clearTimeout(timer);
                }
                if (!state.done) {
                    setBusy(state, false);
                }
                showStatus(state, outcome.message);
                if (outcome.login) { goLogin(state); }
            });
    }

    function bind(state) {
        state.notify.addEventListener("click", function (event) {
            if (event && typeof event.preventDefault === "function") {
                event.preventDefault();
            }
            if (state.done || state.busy) { return; }
            if (state.member || state.kx) {
                submit(state);
            } else {
                goLogin(state);
            }
        });
    }

    function setup(root, settings) {
        var options = settings || {};
        var documentRef = options.document || runtime.document;
        var location = options.location || runtime.location;
        var state = {
            root: root,
            documentRef: documentRef,
            location: location,
            history: options.history || runtime.history,
            loginUrl: (root.getAttribute("data-nk-restock-login-url") || "").trim(),
            member: root.getAttribute("data-nk-restock-member") !== null,
            code: (root.getAttribute("data-nk-restock-code") || "").trim(),
            endpoint: (root.getAttribute("data-nk-restock-endpoint") || "").trim(),
            locale: (root.getAttribute("data-nk-restock-locale") || "en").trim(),
            kx: kxFromLocation(location),
            busy: false,
            done: false,
            fetchRef: options.fetch || (typeof runtime.fetch === "function"
                ? function (url, request) {
                    return runtime.fetch(url, request);
                } : null),
            texts: {
                sending: text(root, "nkRestockSending"),
                done: text(root, "nkRestockDone"),
                doneButton: text(root, "nkRestockDoneButton"),
                already: text(root, "nkRestockAlready"),
                unavailable: text(root, "nkRestockUnavailable"),
                emailInvalid: text(root, "nkRestockEmailInvalid"),
                emailUnknown: text(root, "nkRestockEmailUnknown"),
                rateLimited: text(root, "nkRestockRateLimited"),
                error: text(root, "nkRestockError")
            }
        };
        // 送り先は https の1本だけ。書き損じや別の仕組みのURLでは動かさない。
        if (!/^https:\/\/[^\s"'<>]+$/i.test(state.endpoint)) {
            state.endpoint = "";
        }
        if (!CODE_PATTERN.test(state.code)) {
            state.code = "";
        }
        state.notify = part(root, "notify");
        state.form = part(root, "form");
        state.email = part(root, "email");
        state.website = part(root, "website");
        state.send = part(root, "send");
        state.cancel = part(root, "cancel");
        state.status = part(root, "status");
        if (!state.notify) {
            return null;
        }
        if (!state.code || (!state.member && state.kx && !state.endpoint)) {
            // 受付が閉じている品では、押せるボタンを出したままにしない。
            state.notify.disabled = true;
            return state;
        }
        setHidden(state.form, true);
        bind(state);
        autoJoin(state);
        return state;
    }

    function init(settings) {
        var options = settings || {};
        var documentRef = options.document || runtime.document;
        if (!documentRef || typeof documentRef.querySelectorAll !== "function") {
            return [];
        }
        var roots = documentRef.querySelectorAll("[data-nk-restock-root]");
        var states = [];
        for (var index = 0; index < roots.length; index += 1) {
            var root = roots[index];
            if (bound && bound.has(root)) {
                continue;
            }
            if (bound) {
                bound.add(root);
            }
            var state = setup(root, options);
            if (state) {
                states.push(state);
            }
        }
        return states;
    }

    if (runtime.document) {
        if (runtime.document.readyState === "loading") {
            runtime.document.addEventListener("DOMContentLoaded", function () {
                init();
            });
        } else {
            init();
        }
    }

    runtime.NKRestockNotice = {init: init};
}(typeof window !== "undefined" ? window : this));
